import EditIcon from '../../assets/icons/EditIcon.svg?react';
import useProviderName from '../../hooks/useProviderName';
import XButton from '../common/XButton';
import { medicalProviderHeadingClasses } from '../common/formClasses';

const ProviderName = ({ providerIndex, providerType, isLocked = false }) => {
    const {
        providerName,
        isEditing,
        localProviderName,
        isButonDisabled,
        handleSave,
        handleCancel,
        handleEdit,
        handleChange,
        stopDndPropagation,
    } = useProviderName({ providerIndex, providerType });

    if (isLocked) {
        return (
            <div className="flex items-center gap-2">
                <span className={medicalProviderHeadingClasses}>{providerName}</span>
            </div>
        );
    }

    return (
        <div className="flex items-center gap-2">
            {isEditing ? (
                <div className="relative z-1 flex gap-2">
                    <input
                        type="text"
                        className="form-control"
                        value={localProviderName}
                        onChange={handleChange}
                        onPointerDown={stopDndPropagation}
                        onKeyDown={stopDndPropagation}
                    />
                    <XButton onClick={handleCancel} onPointerDown={stopDndPropagation}>
                        Cancel
                    </XButton>
                    <XButton
                        disabled={isButonDisabled}
                        onClick={handleSave}
                        onPointerDown={stopDndPropagation}
                    >
                        {isButonDisabled ? "Must choose a new provider name" : "Save"}
                    </XButton>
                </div>
            ) : (
                <>
                    <span className={medicalProviderHeadingClasses}>{providerName}</span>
                    <XButton
                        variant="iconGhost"
                        className="relative z-1"
                        onClick={handleEdit}
                        onPointerDown={stopDndPropagation}
                        aria-label="Edit provider name"
                    >
                        <EditIcon />
                    </XButton>
                </>
            )}
        </div>
    );
};

export default ProviderName;
